import { ChoiceMemory } from '../../../../services/choiceMemory/ChoiceMemory';

export function resolveVariableValue(
  choiceMemory: ChoiceMemory | undefined,
  key: string,
): number | string | undefined {
  if (!choiceMemory) return undefined;
  const variable =
    choiceMemory.getVariableById(Number(key)) ??
    choiceMemory.currentVariables?.[key];
  return variable?.value;
}
